module.exports = __webpack_public_path__ + "static/media/hemcapmould1.6f17739e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/medicalDevices/hemcapmould1.jpg
// module id = 229
// module chunks = 0